import { useUserStore } from "@/store/user";
import { useFeatureStore } from "@/store/feature";
import { useLayoutStore } from "@/store/layout";
import { useVisitStore } from "@/store/visit.ts";
import authMiddleware from "@/router/middleware/authMiddleware.ts";
import popupMiddleware from "@/router/middleware/popupMiddleware.ts";
import freeVideoMiddleware from "@/router/middleware/freeVideoMiddleware.ts";
import unsubscribeMailsMiddleware from "@/router/middleware/unsubscribeMailsMiddleware.ts";
import trackMiddleware from "@/router/middleware/trackMiddleware.ts";
import customPageMiddleware from "@/router/middleware/customPageMiddleware.ts";
import playerMiddleware from "@/router/middleware/playerMiddleware.ts";
import metaMiddleware from "@/router/middleware/metaMiddleware.ts";
import landingMiddleware from "@/router/middleware/landingMiddleware.ts";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";
import lawLimitationMiddleware from "@/router/middleware/lawLimitationMiddleware.ts";
import camerasMiddleware from "@/router/middleware/camerasMiddleware.ts";
import manualCancellationMiddleware from "@/router/middleware/manualCancellationMiddleware.ts";
import { FEATURE_AGE_VERIFICATION } from "@/utils/variables.ts";
import { getHomeRedirected, setHomeRedirected } from "@/utils/storage.ts";

export default [
  ({ to }: MiddlewareInterface) => {
    document.title = typeof to.meta.title === "function" ? to.meta.title() : "Ersties";
  },
  trackMiddleware,
  ...authMiddleware,
  async ({ to, redirect, pinia }: MiddlewareInterface) => {
    if (to.matched.some((record) => record.meta.requiresPremium) && !useUserStore(pinia).isPremium) {
      await redirect({
        path: useUserStore(pinia).getLandingUrl,
        query: { redirect: to.fullPath },
      });
    }
  },
  async ({ from, to, redirect, pinia }: MiddlewareInterface) => {
    if (!useUserStore(pinia).isLoggedIn) {
      return true;
    }

    if (to.path === "/") {
      const redirectUrl = useUserStore(pinia).getLandingUrl;

      await redirect({ path: redirectUrl, query: to.query });

      if (from.path === redirectUrl) {
        await useLayoutStore(pinia).setGlobalLoading(false);
      }
    }
  },
  async ({ to, redirect, pinia }: MiddlewareInterface) => {
    if (!useFeatureStore(pinia).hasAgeVerificationFeature) {
      return;
    }

    const path = to.path.replace(/\/+$/, "");

    const redirectHome =
      !useUserStore(pinia).isLoggedIn &&
      !!useVisitStore(pinia).getVisit?.new &&
      !getHomeRedirected() &&
      to.path !== "/" &&
      !!useFeatureStore(pinia).getFeature(FEATURE_AGE_VERIFICATION, true)?.settings?.home_redirect;

    if (path === "/blog" || path === "/lecker_blog" || redirectHome) {
      if (redirectHome) {
        setHomeRedirected();
      }

      await redirect({ path: "/" });
    }
  },
  async ({ to, redirect, pinia }: MiddlewareInterface) => {
    const hasAgeVerification = useFeatureStore(pinia).hasAgeVerificationFeature;

    if (!hasAgeVerification) {
      return;
    }

    const path = to.path.replace(/\/+$/, "");

    if (useUserStore(pinia).isPremium) {
      return false;
    }

    if (hasAgeVerification && (path === "/agb" || path === "/contact-us")) {
      return false;
    }

    if (useFeatureStore(pinia).showDiscountAsPage && path !== "/paywall") {
      await redirect({ path: "/paywall" });
    }
  },
  popupMiddleware,
  lawLimitationMiddleware,
  freeVideoMiddleware,
  camerasMiddleware,
  unsubscribeMailsMiddleware,
  landingMiddleware,
  customPageMiddleware,
  playerMiddleware,
  metaMiddleware,
  manualCancellationMiddleware,
];
